import type React from "react";

interface CelebrateIconProps {
	size?: number;
	className?: string;
}

export const CelebrateIcon: React.FC<CelebrateIconProps> = ({
	size = 24,
	className = "",
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden="true"
	>
		{/* Trophy */}
		<path
			d="M6 9H4.5C3.67 9 3 8.33 3 7.5S3.67 6 4.5 6H6"
			stroke="#4C63B6"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18 9h1.5c.83 0 1.5-.67 1.5-1.5S20.33 6 19.5 6H18"
			stroke="#4C63B6"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18 4H6v5c0 3.31 2.69 6 6 6s6-2.69 6-6V4z"
			fill="#EEF2FF"
			stroke="#4C63B6"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12 15v4M9 19h6"
			stroke="#4C63B6"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		{/* Confetti */}
		<circle cx="4" cy="3" r="1" fill="#FCD34D" />
		<circle cx="20" cy="3" r="1" fill="#86EFAC" />
		<circle cx="3" cy="12" r="1" fill="#A78BFA" />
		<circle cx="21" cy="12" r="1" fill="#FCA5A5" />
	</svg>
);
